<template>
  <div>
    <epi-offcanvas :opening-event-name="openingEventName" title="알림 전송">
      <template v-slot:body></template>
    </epi-offcanvas>
  </div>
</template>

<script>
import { EventName } from "@/const";

export default {
  name: "NotiSendOffcanvas",
  data() {
    return {
      openingEventName: EventName.NotiSendOffcanvasOpening,
    };
  },
};
</script>
